import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper feature14',
      playScale: 0.3,
      always: false,
    },
    page: {
      className: 'home-page feature14-page',
    },
    title: {
      className: 'feature14-title',
      children: [
        {
          name: 'title0',
          className: 'feature14-title-item',
          children: '投资载体',
        },
      ],
    },
    content: {
      name: 'content',
      className: 'feature14-content',
      left: {
        name: 'left',
        className: 'feature14-content-left',
        children: {
          className: 'feature14-content-left-children',
          img: {
            className: 'feature14-content-left-children-img',
            children:
              'https://imm.86links.com/assets/landing/images/%E7%94%BB%E6%9D%BF%402x(2).png',
          },
          box: {
            name: 'box',
            className: 'feature14-content-left-children-box',
            title: {
              name: 'box-title',
              className: 'feature14-content-left-children-box-title',
              children: '重点区域',
            },
            content: {
              className: 'feature14-content-left-children-box-content',
              children: [
                {
                  name: '小标题0',
                  className: 'feature14-content-left-children-box-content-item',
                  children: '· 东岸新城',
                },
                {
                  name: '小标题1',
                  className: 'feature14-content-left-children-box-content-item',
                  children: '· 氢能产业园',
                },
                {
                  name: '小标题2',
                  className: 'feature14-content-left-children-box-content-item',
                  children: '· 中德智能网联汽车四川示范基地',
                },
                {
                  name: '小标题3',
                  className: 'feature14-content-left-children-box-content-item',
                  children: '· 龙泉山城市森林公园（龙泉驿段）',
                },
              ],
            },
          },
        },
      },
      right: {
        name: 'right',
        className: 'feature14-content-right',
        children: [
          {
            name: '项目0',
            className: 'feature14-content-right-item',
            img: {
              className: 'feature14-content-right-item-img',
              children:
                'https://imm.86links.com/assets/landing/images/%E7%94%BB%E6%9D%BF%402x(1).png',
            },
            title: {
              className: 'feature14-content-right-item-title',
              children: '汽车产业',
            },
          },
          {
            name: '项目1',
            className: 'feature14-content-right-item',
            img: {
              className: 'feature14-content-right-item-img',
              children:
                'https://imm.86links.com/assets/landing/images/%E7%94%BB%E6%9D%BF%402x.png',
            },
            title: {
              className: 'feature14-content-right-item-title',
              children: '生态园',
            },
          },
        ],
      },
    },
  },
};
